<template>
  <BaseButton :variant="variant" class="mr-3 left-arrow" @click="$emit('click')">
    <BaseIcon
      v-if="isShowIcon"
      icon-name="leftArrow"
      :width="iconWidth"
      :height="iconHeight"
      class="app--mobile-hidden"
    >
      <IconLeftArrow icon-color="#174169"></IconLeftArrow>
    </BaseIcon>
    <div class="app--hidden app--mobile-shown">
      <img class="mobile-left-arrow" src="../../assets/img/icon/arrow-left.svg" alt="left arrow" />
    </div>
  </BaseButton>
</template>

<script>
import buttonMixin from '@/mixins/button';
import BaseIcon from '@/components/BaseIcon.vue';
import IconLeftArrow from '@/components/icon/IconLeftArrow.vue';

export default {
  mixins: [buttonMixin],
  components: {
    BaseIcon,
    IconLeftArrow,
  },
  props: { variant: { type: String, default: 'outline-primary' } },
};
</script>

<style lang="scss" scoped>
.left-arrow {
  border: none;
  padding: 0;
  margin-right: 20px !important;

  @include respond(phone) {
    margin-right: 10px !important;
  }
}

.mobile-left-arrow {
  height: 16px;
  width: 16px;
}

svg {
  margin-bottom: 4px;
  margin-right: 0;
}
</style>
